import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AiOutlineWarning } from "react-icons/ai";

import ConfirmationModal from "../../../Dialogs/ConfirmationModal";
import { Color } from "../../../Form/Button";
import useStyles from "./styles";

export interface ReceivedByCfsConfirmationModalHandles {
  open: () => void;
  close: () => void;
}
interface ReceivedByCfsConfirmationModalProps {
  closeModal?: () => void;
  onSubmit: () => void;
  loadingAction?: boolean;
}

const ReceivedByCfsConfirmationModal: ForwardRefRenderFunction<
  ReceivedByCfsConfirmationModalHandles,
  ReceivedByCfsConfirmationModalProps
> = (props, ref) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { closeModal, loadingAction, onSubmit } = props;

  const [openModal, setOpenModal] = useState<boolean>(false);
  const open = useCallback(() => {
    setOpenModal(true);
  }, []);
  const close = useCallback(() => {
    setOpenModal(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  return (
    <ConfirmationModal
      width="520px !important"
      open={openModal}
      closeModal={() => {
        if (closeModal) closeModal();
        close();
      }}
      type="warning"
      title={`${translate("changeStatusTo")} "${translate("receivedByCFS")}"`}
      leftIconTitle={<AiOutlineWarning color="#F79009" size={20} />}
      loading={loadingAction}
      cancelDisabled={loadingAction}
      customColorCancel={Color.TEXT_INFO}
      customColorSave={Color.WARNING}
      textCancel={translate("noThanks")}
      textSubmit={translate("confirmAndReceive")}
      submit={() => onSubmit()}
    >
      <Grid container spacing={2} className="mt-2">
        <Grid item className={classes.reviewModalContainer}>
          <div data-cy="confirmationModalWarningBody" className={classes.descriptionModalConfirm}>
            <span>
              {translate("areYouSureYouWantToChangeThisBookingStatusTo")}
              {` "${translate("receivedByCFS")}" ?`}
            </span>
            <span className="warning">
              {translate("weightAndCBMOfThisBookingMustBeConfirmedBeforeThisCanBeDone")}
            </span>
          </div>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(ReceivedByCfsConfirmationModal);
